export enum LedgerFeeType {
	Monthly = 1,
	Weekly = 2,
    OneTime = 3,
    Sanction = 4,
    IncentiveReduction = 5,
    FeeWaiver = 8
}
